import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import NavBar from "../components/NavBar";
import PageContentLoading from "../components/PageContentLoading";
import DistParameter from "../pages/DistParameter";
import useMenu from "../utils/Hooks/useMenu";
import useLocale from "../utils/Hooks/useLocale";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.Configuration,
    key: "Parameter",
  };

  const locale = useLocale(1202);

  return (
    <LocalizationContext.Provider value={{ locale: locale }}>
      <ValidateURL currentPage={currentPage}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          {locale ? <DistParameter /> : <PageContentLoading />}
        </NavBar>
      </ValidateURL>
    </LocalizationContext.Provider>
  );
};

